export const mobileCellStyles = {
  sm: "!hidden sm:!table-cell",
  md: "!hidden md:!table-cell",
  lg: "!hidden lg:!table-cell",
  xl: "!hidden xl:!table-cell",
} as const;
